import { put, takeEvery, takeLatest } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";
import { actions } from "react-redux-form";

//Deps
function* handleForms(action) {
  if (action.meta.filter === "reset_all") {
    yield put(actions.reset("forms.profile"));
    yield put(actions.reset("forms.login"));
  }
}

function* handleResetFormErrors(action) {
  if (action.type === "rrf/change") {
    //Check login password
    if (action.model === "forms.login.password") {
      yield put(actions.reset("forms.errors"));
    }
  }
  if (action.type === "rrf/focus") {
    //Check signUp email
    if (action.model === "forms.signUp.email") {
      yield put(actions.reset("forms.errors"));
    }
    //Check login email
    if (action.model === "forms.login.email") {
      yield put(actions.reset("forms.errors"));
    }
  }
}

export function* formWatcher() {
  yield takeEvery(ACTIONS.HANDLE_FORMS, handleForms);
}

export function* resetFormErrors() {
  yield takeLatest(
    action => action.type.substring(0, 3) === "rrf",
    handleResetFormErrors
  );
}



// WEBPACK FOOTER //
// ./src/sagas/forms.js